let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("14AZs")).then(() => parcelRequire('l9Ug4'));